import { useContext } from "react";
import { ChatSocketContext, type ChatSocketValue } from "./ChatSocketContext";

export function useChatSocketContext(): ChatSocketValue {
  const ctx = useContext(ChatSocketContext);
  if (!ctx) {
    throw new Error(
      "useChatSocketContext must be used inside <ChatSocketProvider>"
    );
  }
  return ctx;
}
